export class MetaTag {
    name: string;
    value: string;
    itemProp: string;

    constructor(name: string, value: string, itemProp: string) {
        this.name = name;
        this.value = value;
        this.itemProp = itemProp;
    }
}
